
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import { Line, mixins } from 'vue-chartjs'
import { ChartData, ChartOptions, ChartDataSets } from 'chart.js'

const hasProperty = (obj: any, key: any): key is keyof typeof obj =>
  !!obj && Object.prototype.hasOwnProperty.call(obj, key)

@Component({
  extends: Line
})
export default class ECGChart extends Mixins(Line, mixins.reactiveProp) {
  @Prop({
    type: Object,
    required: true,
    default: () => ({})
  })
  chartData!: ChartData
  get options(): ChartOptions {
    if (!this.chartData) return {}
    return {
      scales: {
        xAxes: [
          {
            ticks: {
              maxTicksLimit: (this.chartData.datasets?.length || 1) * 3
            },
            display: false
          }
        ],
        yAxes: [
          {
            ticks: {
              min: -2.5,
              max: 2.5
            }
          }
        ]
      },
      responsive: false,
      maintainAspectRatio: false,
      tooltips: {
        enabled: false
      },
      legend: {
        display: false
      }
    }
  }

  mounted() {
    this.renderChart(this.chartData, this.options)
  }

  @Watch('chartData')
  dataHandler(newData: ChartData, oldData: ChartData) {
    if (oldData) {
      const chart = this.$data._chart
      // Get new and old DataSet Labels
      const newDatasetLabels = newData.datasets?.map((dataset: any) => {
        return dataset.label
      })

      const oldDatasetLabels = oldData.datasets?.map((dataset: any) => {
        return dataset.label
      })

      // Stringify 'em for easier compare
      const oldLabels = JSON.stringify(oldDatasetLabels)
      const newLabels = JSON.stringify(newDatasetLabels)

      // Check if Labels are equal and if dataset length is equal
      if (
        newLabels === oldLabels &&
        oldData.datasets?.length === newData.datasets?.length
      ) {
        newData.datasets?.forEach((dataset, i) => {
          // Get new and old dataset keys
          if (!oldData.datasets) return
          const oldDatasetKeys = Object.keys(oldData.datasets[i])
          const newDatasetKeys = Object.keys(dataset)

          // Get keys that aren't present in the new data
          const deletionKeys = oldDatasetKeys.filter(key => {
            return key !== '_meta' && newDatasetKeys.indexOf(key) === -1
          })

          // Remove outdated key-value pairs
          deletionKeys.forEach(deletionKey => {
            delete chart.data.datasets[i][deletionKey]
          })

          // Update attributes individually to avoid re-rendering the entire chart
          for (const attribute in dataset) {
            if (hasProperty(dataset, attribute)) {
              chart.data.datasets[i][attribute] =
                dataset[attribute as keyof ChartDataSets]
            }
          }
        })

        if (hasProperty(newData, 'labels')) {
          chart.data.labels = newData.labels
          this.$emit('labels:update')
        }
        if (hasProperty(newData, 'xLabels')) {
          // chart.data.xLabels = newData.xLabels
          this.$emit('xlabels:update')
        }
        if (hasProperty(newData, 'yLabels')) {
          // chart.data.yLabels = newData.yLabels
          this.$emit('ylabels:update')
        }
        chart.update({ duration: 0 })
        this.$emit('chart:update')
      } else {
        if (chart) {
          chart.destroy()
          this.$emit('chart:destroy')
        }
        this.renderChart(this.chartData, this.options)
        this.$emit('chart:render')
      }
    } else {
      if (this.$data._chart) {
        this.$data._chart.destroy()
        this.$emit('chart:destroy')
      }
      this.renderChart(this.chartData, this.options)
      this.$emit('chart:render')
    }
  }
}
